import React, { Component } from "react";
import ReactDOM from "react-dom";
import OktaSignIn from "@okta/okta-signin-widget/dist/js/okta-sign-in.min";
import logo from "images/mlb-okta-logo.png";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import "@okta/okta-signin-widget/dist/css/okta-theme.css";

/**
 * This component was fork lifted from the okta-react documentation.
 * See https://developer.okta.com/code/react/okta_react_sign-in_widget for more info.
 */
export default class OktaSignInWidget extends Component {
  componentDidMount() {
    const el = ReactDOM.findDOMNode(this);
    this.widget = new OktaSignIn({
      baseUrl: this.props.baseUrl,
      logo
    });
    this.widget.renderEl({ el }, this.props.onSuccess, this.props.onError);
  }

  componentWillUnmount() {
    this.widget.remove();
  }

  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/components/OktaSignInWidget.js